import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";

interface ChangePassword {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

interface ChangePasswordState {
    changepassworddata: ChangePassword | null;
    error: string | null;
    loading: boolean;
}

export const ChangePassword = createAsyncThunk<
    ChangePassword,
    ChangePassword,
    { rejectValue: string }
>(
    'changepassword/changePassword',
    async (args, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/api/admin/change-password`, args);
            return response.data;
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);


const initialState: ChangePasswordState = {
    changepassworddata: null,
    error: null,
    loading: false,
}

const changePasswordSlice = createSlice({
    name: "changepassword",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(ChangePassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ChangePassword.fulfilled, (state, action: PayloadAction<ChangePassword>) => {
                state.loading = false;
                state.changepassworddata = action.payload;
            })
            .addCase(ChangePassword.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'Failed to change password';
            });
    },
});

export default changePasswordSlice.reducer;
